import Axios from "axios";
import store from "@/store";
import router from "@/router";

const api = Axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    "X-Api-Key": process.env.VUE_APP_API_KEY,
  },
  timeout: 0,
});

// ✅ Interceptor de requisição: adiciona token dinâmico
api.interceptors.request.use(
  (config) => {
    const token = store.getters.accessToken;
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// ✅ Função de signOut
function signOutLocal(error) {
  store.dispatch("setSignOut");

  router.push({ path: "/auth" }).catch(() => {
    /* ignora múltiplos redirecionamentos */
  });

  return Promise.reject(error);
}

// ✅ Interceptor de resposta: trata erros e tenta refresh
api.interceptors.response.use(
  (response) => Promise.resolve(response),
  async (error) => {
    const { response, config, message } = error;

    // Erro de rede (sem resposta do servidor)
    if (message === "Network Error" && store.getters.accessToken) {
      return signOutLocal(error);
    }

    // Erros sem resposta do servidor (ex: timeout)
    if (!response) {
      return Promise.reject(error);
    }

    // Se for 401 (unauthorized)
    if (response.status === 401) {
      const refreshToken = store.getters.refreshToken;

      const ignoredRoutes = ["/auth", "/auth/refresh"];
      const isIgnoredRoute = ignoredRoutes.includes(config.url);
      const isLoadSessionRoute = isIgnoredRoute && config.method === "get";

      if ((isIgnoredRoute && !isLoadSessionRoute) || !refreshToken) {
        return signOutLocal(error);
      }

      try {
        // Tenta refresh
        const { data } = await api.put("/auth/refresh", { refreshToken });

        // Atualiza tokens na store
        await store.dispatch("setAccessToken", data.accessToken);
        await store.dispatch("setRefreshToken", data.refreshToken);

        // Reenvia a requisição original com novo token
        config.headers.Authorization = data.accessToken;
        return Axios(config);
      } catch (err) {
        return signOutLocal(err);
      }
    }

    // Outros erros
    return Promise.reject(response);
  }
);

export default api;
